$('#activity_submit_btn').click(function() {
  var input_index = 1
  var input_length = 0
  var area_length = 0
  var area_index = 1
  var form_data = []
  var submit = false
  input_length = $("#activity-input-box").children().length
  area_length = $("#activity-textarea-box").children().length
  
  for (var i = input_index; i < input_length; i++) {
    let value = $(`#form_id_${i}`).val()
    let name = $(`#form_id_${i}`).prev().html()
    console.log(name)
    if (name !== undefined && name.substr(name.length - 1, 1) === '*'){
      if (value === '') {
        submit = true
        $(`#form_tip_${i}`).css('display', 'block')
      } else{
        $(`#form_tip_${i}`).css('display', 'none')
      }
    }
    form_data.push({
      value: value,
      name: name
    });
  }
  for (var x = area_index; x < area_length; x++) {
    let value = $(`#form_textarea_id_${x}`).val()
    let name = $(`#form_textarea_id_${x}`).prev().html()
    form_data.push({
      value: value,
      name: name
    });
  }
  if (submit) {
    return false
  }
  const data = { 
    data: form_data,
    form_name: $('#form_name').val(),
    send_email: null,
    web: window.location.host
  }
  var send_email = $("#form_send_email").val()
  if ( send_email !== '' ) {
    data.send_email = send_email
  }

  $.ajax({  
    type: "POST",  
    url: "https://service.infiai.tech/ms_activity_form/email",  
    contentType: 'application/x-www-form-urlencoded;charset=utf-8',
    data: data,
    dataType: "json",  
    success: function(res) {
      console.log(res)
      if(res.code === 200) {
        $('#activity-succeed').css('display', 'block')
      }
    },
    error:function(error) {  
      console.log(error);
    }
  })
})
